require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./decorator"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./decorator"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./decorator")) : factory(root["./utils"], root["./decorator"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__87__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[58],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(497);


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;

var _SVGIcon = _interopRequireWildcard(__webpack_require__(498));

exports["default"] = _SVGIcon["default"];
exports.SVGIcon = _SVGIcon["default"];
exports.SVGIconDecoration = _SVGIcon.SVGIconDecoration;
exports.createIcon = _SVGIcon.createIcon;

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports.createIcon = createIcon;
exports.SVGIconDecoration = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _decorator = _interopRequireWildcard(__webpack_require__(87));

var _SVGIcon = _interopRequireDefault(__webpack_require__(499));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var svgIconClassName = _SVGIcon["default"].svgIconClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    BaPropTypes = _utils.propsUtils.BaPropTypes;

var SVGIcon = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(SVGIcon, _Component);

  function SVGIcon() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      showFocusClass: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_isIconObject", function () {
      var icon = _this.props.icon;
      return typeof icon === 'object' && icon !== null;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyUp", function (e) {
      _this.props.onKeyUp && _this.props.onKeyUp(e);

      if (e.keyCode === 9) {
        _this.setState({
          showFocusClass: true
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
      _this.props.onBlur && _this.props.onBlur(e);

      _this.setState({
        showFocusClass: false
      });
    });
    return _this;
  }

  var _proto = SVGIcon.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        className = _this$props.className,
        _iconId = _this$props.iconId,
        icon = _this$props.icon,
        height = _this$props.height,
        width = _this$props.width,
        rotate = _this$props.rotate,
        size = _this$props.size,
        pad = _this$props.pad,
        intent = _this$props.intent,
        children = _this$props.children,
        focusable = _this$props.focusable,
        themable = _this$props.themable,
        ariaLabelledby = _this$props.ariaLabelledby,
        ariaDescribedby = _this$props.ariaDescribedby,
        alt = _this$props.alt,
        desc = _this$props.desc,
        style = _this$props.style,
        bidi = _this$props.bidi,
        disabled = _this$props.disabled,
        verticalAlign = _this$props.verticalAlign,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["className", "iconId", "icon", "height", "width", "rotate", "size", "pad", "intent", "children", "focusable", "themable", "ariaLabelledby", "ariaDescribedby", "alt", "desc", "style", "bidi", "disabled", "verticalAlign"]);
    var iconId = _iconId || (typeof icon === 'string' ? icon : _utils.lodash.get(icon, 'id', ''));
    var styles;

    if (height > 0 && width > 0) {
      styles = {
        height: height,
        width: width
      };
    }

    if (rotate) {
      if (!styles) {
        styles = {};
      }

      styles.WebkitTransform = "rotate(" + rotate + "deg)";
      styles.transform = "rotate(" + rotate + "deg)";
    }

    styles = (0, _extends2["default"])({}, styles, {
      verticalAlign: verticalAlign
    }, style);
    var hasA11yTitle = ariaLabelledby !== undefined && ariaLabelledby !== null;
    var hasA11yDesc = ariaDescribedby !== undefined && ariaDescribedby !== null;
    var isA11y = hasA11yTitle || hasA11yDesc;
    var clickable = isA11y || other.onClick || other.onMouseDown || other.onMouseUp || other.onMouseOver || other.onMouseOut || other.onMouseLeave || other.onMouseEnter;
    var classNames = (0, _utils.classnames)(svgIconClassName, (_cx = {}, _cx[size] = !this._isIconObject(), _cx["intent_" + intent] = intent && !themable, _cx.pad = pad, _cx.clickable = clickable, _cx.focus = this.state.showFocusClass, _cx.bidi = bidi, _cx.disabled = disabled, _cx));
    var a11yProps = isA11y ? {
      role: 'img',
      'aria-labelledby': (hasA11yTitle ? ariaLabelledby : '') + " " + (hasA11yDesc ? ariaDescribedby : '')
    } : '';
    var dimension = {};

    if (this._isIconObject()) {
      var _this$props$icon$view = this.props.icon.viewBox.split(' ').splice(-2),
          sWidth = _this$props$icon$view[0],
          sHeight = _this$props$icon$view[1];

      dimension.width = sWidth;
      dimension.height = sHeight;
    }

    var svg = /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
      focusable: "" + focusable
    }, sanitize(other), {
      className: classNames + " " + className
    }, dimension, {
      style: styles,
      onKeyUp: this._onKeyUp,
      onBlur: this._onBlur
    }, a11yProps), hasA11yTitle ? /*#__PURE__*/_react["default"].createElement("title", {
      id: ariaLabelledby
    }, alt) : '', hasA11yDesc ? /*#__PURE__*/_react["default"].createElement("desc", {
      id: ariaDescribedby
    }, desc) : '', /*#__PURE__*/_react["default"].createElement("use", {
      className: themable ? 'ba-graphics-themable' : '',
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xlinkHref: "#" + iconId
    }));

    if (children) {
      // if (children.type.name === 'Flyout') {
      //     return (
      //         <span>
      //             { svg }
      //             <Decorator style={{ position: 'absolute' }}>
      //                 { children }
      //             </Decorator>
      //         </span>
      //     );
      // }
      return /*#__PURE__*/_react["default"].createElement(_decorator["default"], null, svg, children);
    }

    return svg;
  };

  return SVGIcon;
}(_react.Component);

exports["default"] = SVGIcon;
(0, _defineProperty2["default"])(SVGIcon, "propTypes", {
  className: _propTypes["default"].string,

  /** Either iconId or icon is required customPropTypes: [string, Object] */
  iconId: BaPropTypes.requiredIf(_propTypes["default"].oneOfType([_propTypes["default"].string]), function (props) {
    return !Object.prototype.hasOwnProperty.call(props, 'icon');
  }),

  /** One of <icon.id> or <ba-graphics icon object> customPropTypes: [string, Object] */
  icon: BaPropTypes.requiredIf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]), function (props) {
    return !Object.prototype.hasOwnProperty.call(props, 'iconId');
  }),
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  focusable: _propTypes["default"].bool,
  height: _propTypes["default"].number,
  width: _propTypes["default"].number,
  rotate: _propTypes["default"].number,
  size: _propTypes["default"].oneOf(['tiny', 'small', 'normal', 'large', 'xlarge', 'xxlarge']),
  intent: _propTypes["default"].oneOf(['', 'primary', 'positive', 'danger', 'warning', 'info']),
  themable: _propTypes["default"].bool,
  pad: _propTypes["default"].bool,
  ariaLabelledby: _propTypes["default"].string,
  ariaDescribedby: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  desc: _propTypes["default"].string,
  style: _propTypes["default"].object,
  bidi: _propTypes["default"].bool,
  onKeyUp: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  verticalAlign: _propTypes["default"].oneOf(['baseline', 'top', 'middle', 'bottom', 'sub', 'text-top', 'unset', 'inherit', 'initial']),
  onClick: _propTypes["default"].func
});
(0, _defineProperty2["default"])(SVGIcon, "defaultProps", {
  verticalAlign: 'bottom',
  size: 'small',
  focusable: false,
  className: '',
  style: {},
  bidi: false
});

var SVGIconDecoration = /*#__PURE__*/function (_Component2) {
  (0, _inheritsLoose2["default"])(SVGIconDecoration, _Component2);

  function SVGIconDecoration() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = SVGIconDecoration.prototype;

  _proto2.render = function render() {
    var _this$props2 = this.props,
        location = _this$props2.location,
        x = _this$props2.x,
        y = _this$props2.y,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["location", "x", "y"]);
    return /*#__PURE__*/_react["default"].createElement(_decorator.Decoration, {
      location: location,
      x: x,
      y: y
    }, /*#__PURE__*/_react["default"].createElement(SVGIcon, (0, _extends2["default"])({
      size: "small"
    }, other)));
  };

  return SVGIconDecoration;
}(_react.Component);

exports.SVGIconDecoration = SVGIconDecoration;
(0, _defineProperty2["default"])(SVGIconDecoration, "propTypes", {
  location: _decorator.Decoration.propTypes.location,
  x: _decorator.Decoration.propTypes.x,
  y: _decorator.Decoration.propTypes.y
});

function createIcon(icon, size, componetClassName, locationClass, props) {
  if (!icon) {
    return null;
  } // if we have a react component pass it through otherwise SVGIcon will now handle icon.id(string) or icon(object)


  var iconComponent = _react["default"].isValidElement(icon) ? props ? _react["default"].cloneElement(icon, props) : icon : /*#__PURE__*/_react["default"].createElement(SVGIcon, (0, _extends2["default"])({}, size ? {
    size: size
  } : {}, {
    focusable: false,
    icon: icon
  }, props));
  return locationClass ? /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _utils.classnames)(componetClassName + "__icon", locationClass)
  }, iconComponent) : iconComponent;
}

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(500);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "@-moz-document url-prefix(){.glass.highcontrast .ba-common-svgIcon{fill:currentColor !important}}.ba-common-svgIcon{color:inherit;fill:currentColor;box-sizing:content-box !important;pointer-events:auto}.ba-common-svgIcon.is-tiny{width:12px;height:12px}.ba-common-svgIcon.is-small{width:16px;height:16px}.ba-common-svgIcon.is-normal{width:24px;height:24px}.ba-common-svgIcon.is-large{width:32px;height:32px}.ba-common-svgIcon.is-xlarge{width:64px;height:64px}.ba-common-svgIcon.is-xxlarge{width:128px;height:128px}.ba-common-svgIcon.is-12{width:12px;height:12px}.ba-common-svgIcon.is-16{width:16px;height:16px}.ba-common-svgIcon.is-24{width:24px;height:24px}.ba-common-svgIcon.is-32{width:32px;height:32px}.ba-common-svgIcon.is-64{width:64px;height:64px}.ba-common-svgIcon.is-128{width:128px;height:128px}.ba-common-svgIcon.is-pad{padding:8px}.ba-common-svgIcon.is-clickable{cursor:pointer}.ba-common-svgIcon:not(.is-clickable){pointer-events:none}[dir='rtl'] .ba-common-svgIcon.is-bidi{transform:scaleX(-1)}.ba-common-svgIcon:focus{outline:none}.svgIcon-page-display{width:100px;margin:16px 0;height:10px;display:inline-block}.svgIcon-page-display .ba-common-svgIcon.is-pad{background-clip:content-box;box-shadow:inset 0 0 0 8px #393939;box-shadow:inset 0 0 0 8px var(--interactive-02, #393939)}.ba-common-svgIcon{transition-timing-function:cubic-bezier(0.2, 0, 0.38, 0.9)}.ba-common-svgIcon.is-focus{outline:2px solid;outline-color:#a8c0f3}.ba-common-svgIcon.is-intent_primary{fill:#161616}.ba-common-svgIcon.is-intent_positive{fill:#24a148}.ba-common-svgIcon.is-intent_warning{fill:#f1c21b}.ba-common-svgIcon.is-intent_danger{fill:#da1e28}.ba-common-svgIcon.is-intent_info{fill:#0043ce}.is-disabled{fill:#c6c6c6}\n", ""]);

// exports
exports.locals = {
	"svgIconClassName": "\"ba-common-svgIcon\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__87__;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[496,0]]]);
});